export default __webpack_public_path__ + "locales/sq-AL/DataReassignmentDialog.json?hash=a0121cf42f203a85153c433fac9a8cba";